// JsFromRoutes CacheKey 6cdeb5e5fb1115e2c555923df8105049
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  get: definePathHelper('get', '/clips/export'),
  create: definePathHelper('post', '/clips/export'),
}
